// extracted by mini-css-extract-plugin
export var isPrintedCell = "_yc-1";
export var printerIcon = "_yc-0";